import IoTAPI from "./api/IoTAPI";
import DevAPI from "./api/DevAPI";
import GinIoTAPI from "./api/GinIoTAPI";
import { axiosGet } from "./api/wrapperAPI";

const get = (url: string, type?: string) => {
  switch (type) {
    case "dev":
      return DevAPI.get("/feedmaker" + url);
    case "gin":
      return GinIoTAPI.get("/feedmaker" + url);
    default:
      return IoTAPI.get("/feedmaker" + url);
  }
};

export const getFeedMakerInfo = (deviceID: string) =>
  axiosGet(get(`/${deviceID}`));
